<template>
  <section class="slider-container">
    <swiper
      :slides-per-view="calculateSlidesPerView()"
      :spaceBetween="20"
      :autoplay="{ delay: 2500, disableOnInteraction: false }"
      :pagination="{ clickable: true }"
      :navigation="true"
      :modules="modules"
      class="mySwiper"
    >
<swiper-slide
  v-for="animal in animaux"
  :key="animal.id"
>
  <router-link
    :to="'/animaux/' + animal.id"
    class="card-link"
  >
    <div class="animal-card">
      <div class="animal-image">
        <img
          :src="getImage(animal)"
          :alt="animal.type + ' ' + animal.name"
        />
      </div>

      <div class="animal-info">
        <h5 class="animal-name">
          {{ animal.name }}
          <span class="animal-icon">
            {{ animal.type === 'chat' ? '🐱' : '🐶' }}
          </span>
        </h5>

        <p class="animal-detail">
          <strong>Âge :</strong> {{ calculateAge(animal.naissance) }}
        </p>

        <p class="animal-detail">
          <strong>Race :</strong> {{ animal.race }}
        </p>
      </div>
    </div>
  </router-link>
</swiper-slide>

    </swiper>
  </section>
</template>

<script>
// Swiper
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { Autoplay, Pagination, Navigation } from 'swiper/modules'

// Utils
import convertAge from './getAge.js'

export default {
  name: 'homeData',

  components: {
    Swiper,
    SwiperSlide
  },

  props: {
    chiens: {
      type: Array,
      default: () => []
    },
    chats: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    animaux() {
      return [...this.chiens, ...this.chats]
    }
  },

  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation]
    }
  },

  methods: {
    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth)
    },

    calculateSlidesPerView() {
      return window.innerWidth < 900 ? 1 : 5
    },

    getImage(animal) {
      if (animal.img1) {
        return 'https://admin.asso-refuge.fr/images/' + animal.img1
      }

      return animal.type === 'chat'
        ? 'https://www.admin.spadesavoie.fr/images/chatmanquant.png'
        : 'https://www.admin.spadesavoie.fr/images/chienmanquant.png'
    }
  }
}
</script>

<style scoped>
.slider-container {
  margin: 40px 0;
}
.card-link {
  text-decoration: none;
  color: inherit;
}

.card-link:hover {
  color: inherit;
}
.animal-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.animal-image img {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.animal-info {
  padding: 15px;
  text-align: center;
}

.animal-name {
  font-weight: bold;
  margin-bottom: 8px;
}

.animal-icon {
  margin-left: 6px;
}

.animal-detail {
  margin: 0;
  font-size: 14px;
}
</style>
